import React from 'react';
import getBaseTitle from './getBaseTitle';

const getArrayValueTitle = (confirmedData) => {
  if (!confirmedData?.value || !confirmedData?.operator) return '';
  const isSingleValue = confirmedData.value.length === 1;
  const firstValue = confirmedData.value[0];
  const valueCount = confirmedData.value.length;

  const getValueText = (item) => item?.name || item?.title || item?.displayName || item;

  if (valueCount > 1) {
    return (
      <>
        <span className="searchFilterItem__subtitle">
          {getBaseTitle({
            text: getValueText(firstValue),
            operator: confirmedData.operator,
            isSingle: isSingleValue,
          })}
        </span>
        &nbsp;
        {(confirmedData.operator === 'oneOfExceptAllOf' || confirmedData.operator === 'oneOfExceptOneOf' || confirmedData.operator === 'oneOf') && 'or'}
        {(confirmedData.operator === 'allOfExceptAllOf' || confirmedData.operator === 'allOfExceptOneOf' || confirmedData.operator === 'allOf') && 'and'}
        &nbsp;
        <span>{`+${valueCount - 1}`}</span>
      </>
    );
  }

  return (
    <span className="searchFilterItem__subtitle">
      {getBaseTitle({
        text: confirmedData.value.map(getValueText).join(', '),
        operator: confirmedData.operator,
        isSingle: isSingleValue,
      })}
    </span>
  );
};

export default getArrayValueTitle;
